module.exports = "/_next/static/images/img-login-fdf3a8066e7189637187cd38afc3a8d7.png";